
<div class="container p-3">
  <h2>Counselling Group Session</h2>
    <div class="row">
      <mat-form-field appearance="outline" class="col-md-4">
        <mat-label>Participants</mat-label>
        <mat-select required  [(ngModel)]="particiapant">
          <mat-option *ngFor="let t of types" [value]="t">{{t}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-4">
        <mat-label>Select Centre</mat-label>
        <mat-select  [(ngModel)]="selectedCentre">
          <mat-option *ngFor=" let c of (centres) "
                      [value]="c">{{c.centreName}} </mat-option>
          <!--      <mat-option  value="All">All Centres</mat-option>-->
        </mat-select>
      </mat-form-field>
<prettyjson [obj]="selectedCentre"></prettyjson>
<!--      <mat-form-field appearance="outline" class="col-md-4">-->
<!--        <mat-label >Select Name of Councelor</mat-label>-->
<!--        <mat-select  aria-label="Default select example" [(ngModel)]="counselorName">-->
<!--          <mat-option *ngFor="let e of (employee|async)" [value]="e.userName"> {{e.userName}}</mat-option>-->

<!--        </mat-select>-->
<!--      </mat-form-field>-->

      <mat-form-field appearance="outline" class="col-md-4">
        <mat-label>Session Topic</mat-label>
        <mat-select multiple [(ngModel)]="sessionTopics">
          <mat-option value="Personal Hygiene">Personal Hygiene</mat-option>
          <mat-option value="Rules & Guidelines"> Rules & Guidelines</mat-option>
          <mat-option value="Bereavement"> Bereavement</mat-option>
          <mat-option value="Theme Base Session"> Theme Base Session</mat-option>
          <mat-option value="Covid-19 Pandemic"> Covid-19 Pandemic</mat-option>
          <mat-option value="Stress & Building Resilience"> Stress & Building Resilience</mat-option>
          <mat-option value="Any Activity"> Any Activity</mat-option>
          <mat-option value="Others"> Others</mat-option>
        </mat-select>
      </mat-form-field>
<!--      <mat-form-field appearance='outline' class="col-md-4">-->
<!--        <mat-label>-->
<!--          Target Group-->
<!--        </mat-label>-->

<!--        <mat-select [(ngModel)]="targetGroup">-->
<!--          <mat-option value="Male">Male</mat-option>-->
<!--          <mat-option value="Female">Female</mat-option>-->
<!--          <mat-option value="Family">Family</mat-option>-->
<!--          <mat-option value="Child">Child</mat-option>-->
<!--        </mat-select>-->
<!--      </mat-form-field>-->


      <mat-form-field appearance="outline" class="col-md-4">
        <mat-label>From</mat-label>
        <input matInput [matDatepicker]="startDatePicker" [(ngModel)]="startDate" readonly>
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-4">
        <mat-label>To</mat-label>
        <input matInput [matDatepicker]="endDatePicker" [(ngModel)]="endDate" readonly>
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker></mat-datepicker>
      </mat-form-field>
<!--      <mat-form-field appearance="outline" class="col-md-4">-->
<!--        <input matInput [matDatepicker]="picker" formControlName="dateOfAdmission" readonly>-->
<!--        <mat-hint>DD/MM/YYYY</mat-hint>-->
<!--        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>-->
<!--        <mat-datepicker #picker></mat-datepicker>-->
<!--    </mat-form-field>-->
<!--      <mat-form-field appearance="outline" class="col-md-4">-->
<!--        <mat-label >Custom Date</mat-label>-->
<!--        <mat-select  aria-label="Default select example"  >-->
<!--          <mat-option>Select Custom Date</mat-option>-->
<!--        </mat-select>-->

   <div class="row">
     <mat-form-field appearance="legacy" class="col-md-6">
       <mat-label><span class="bi bi-search me-2"></span>Select Name</mat-label>
       <input matInput  (input)="applyFilter($event)" placeholder="Select Name" #input>
     </mat-form-field>

     <div class="col-md-6 text-end ">
       &nbsp;&nbsp;<button mat-mini-fab color="accent"  matTooltip="Search" (click)="Search()">
       <mat-icon>search</mat-icon>
     </button>&nbsp;&nbsp;&nbsp;&nbsp;
       &nbsp;&nbsp;&nbsp;&nbsp;   <button mat-mini-fab color="accent"  (click)="clearAll()" matTooltip="Clear">
       <mat-icon>clear</mat-icon>

     </button>
     </div>
   </div>



    </div>



    <section>
      <h3 class="text-center" style="background-color:grey;font-weight:700">List</h3>
    </section>

<section class="example-container">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

    <!-- Position Column -->
    <!--        <ng-container matColumnDef="position">-->
    <!--            <th mat-header-cell *matHeaderCellDef> No. </th>-->
    <!--            <td mat-cell *matCellDef="let element"> {{element.}} </td>-->
    <!--        </ng-container>-->
    <!-- Name Column -->
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Created At </th>
      <td mat-cell *matCellDef="let element"> <span *ngIf='element.createdAt' >{{element?.createdAt|date:'dd/MM/yyyy' }}</span> </td>
    </ng-container>
    <!-- Name Column -->
    <ng-container matColumnDef="children">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Names </th>
      <td mat-cell *matCellDef="let element"> {{ getchildNames(element.children)}} </td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="centres">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Centres </th>
      <td mat-cell *matCellDef="let element"> {{getCenterNames(element.centres)}} </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="topicsCovered">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Topics Covered </th>
      <td mat-cell *matCellDef="let element">{{(getTopicsCovered(element.topicsCovered) )}} </td>
    </ng-container>
    <!-- Symbol Column -->
    <ng-container matColumnDef="participants">
      <th mat-header-cell *matHeaderCellDef> Participants </th>
      <td mat-cell *matCellDef="let element">{{(getTopicsCovered(element.participants) )}} </td>
    </ng-container>

    <ng-container matColumnDef="Action">
      <th mat-header-cell *matHeaderCellDef>Action</th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button color="accent" (click)="viewDialog(element)" matTooltip="View"><mat-icon>remove_red_eye</mat-icon></button>

      </td>
    </ng-container>
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef> Date of Session </th>
      <td mat-cell *matCellDef="let element"> {{(element.date).toDate() | date: 'dd/MM/yyyy' }} </td>
    </ng-container>.
    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4"><span *ngIf="selectedCentre==''"> No Centre Selected</span>
        <span *ngIf="selectedCentre!=''">No data matching the filter "{{input.value}}"</span></td>
    </tr>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[25,50,100,200,250,500,1000]" aria-label="Select page of users"></mat-paginator>

</section>

</div>

